import React from "react";
import { Check } from "lucide-react";
import { useI18n } from "@/lib/i18n";
import { IDR } from "@/lib/format";
// A narrow, fixed-width field: the shared `inputClass` carries `w-full`, which would swallow the size label.
const qtyInputClass =
  "w-14 shrink-0 text-center bg-transparent border-b border-[#2A2A2A] rounded-none px-0 py-2 text-base sm:text-sm text-[#F3F3F1] focus:border-[#D4AF37] focus:outline-none";

/** One catalogue size: checkbox, price, and the copies field once it is included. */
export const MandatoryPrintRow = ({ size, price, row, onToggle, onQty, testIdPrefix }) => {
  const { t } = useI18n();
  const on = !!row;

  return (
    <div className={`flex items-center gap-2 px-4 py-3 min-h-[48px] transition-colors ${
      on ? "bg-[#D4AF37]/[0.08]" : "bg-[#0B0B0B]"
    }`}>
      <button type="button" data-testid={`${testIdPrefix}-option-${size}`}
        onClick={onToggle} aria-pressed={on}
        className="flex items-center gap-3 text-left min-w-0 flex-1">
        <span className={`w-5 h-5 shrink-0 border flex items-center justify-center transition-colors ${
          on ? "bg-[#D4AF37] border-[#D4AF37] text-black" : "border-[#3a3a3a]"
        }`}>
          {on && <Check size={13} strokeWidth={3} />}
        </span>
        <span className="min-w-0 flex-1">
          <span className={`block text-sm truncate ${on ? "text-[#F3F3F1]" : "text-[#A8A8A8]"}`}>{size}</span>
          <span className="block font-mono-accent text-[10px] text-[#707070] truncate">{IDR(price)}</span>
        </span>
      </button>
      {on && (
        <input data-testid={`${testIdPrefix}-qty-${size}`} type="number" min="1"
          className={qtyInputClass} value={row.qty}
          onChange={(e) => onQty(e.target.value)} aria-label={`${size} ${t("print_qty")}`} />
      )}
    </div>
  );
};

/** Sizes the project still carries that no longer exist in the price catalogue. */
export const LegacyQuotaRows = ({ rows, onQty, onRemove, testIdPrefix }) => {
  const { t } = useI18n();

  return (
    <div className="mt-4 border-l-2 border-[#8B0000] pl-4 py-1" data-testid={`${testIdPrefix}-legacy`}>
      <p className="text-xs text-[#F3F3F1]">{t("unpriced_sizes_title")}</p>
      <div className="mt-2 space-y-2">
        {rows.map((row) => (
          <div key={row._k || row.size} className="flex items-center gap-3">
            <span className="font-mono-accent text-[11px] text-[#D4AF37] flex-1 truncate">{row.size}</span>
            <input data-testid={`${testIdPrefix}-legacy-qty-${row.size}`} type="number" min="1"
              className={qtyInputClass} value={row.qty}
              onChange={(e) => onQty(row.size, e.target.value)} aria-label={`${row.size} ${t("print_qty")}`} />
            <button type="button" data-testid={`${testIdPrefix}-legacy-remove-${row.size}`}
              onClick={() => onRemove(row.size)}
              className="text-[10px] tracking-[0.16em] uppercase text-[#707070] hover:text-[#8B0000]">
              {t("remove")}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};
